/**
 * The visitor sees no emoji (owner, 08.10.2026) — and what the backend writes
 * (the model's Markdown, chips, a card's titles and captions, a plan stop like
 * «🍽 обед») still carries them. They are taken out WHEN DRAWN, here, one
 * function for everything: the data keeps them (`attachmentsAdapter` reads a
 * «📌» subtitle as a fact) and a button still SENDS its text byte for byte — so
 * call this on the way to the screen, never on what is stored or sent.
 *
 * Service marks that are letters of the interface, not pictures, stay:
 * ✓ ✕ → ↗ ★ and the like. An emoji is: a default-emoji character, anything in
 * the pictograph planes, a dingbat/misc-symbol with a pictographic look
 * (⚠ ☀ ✈ …), any pictographic character asked for in emoji form with U+FE0F
 * (ℹ️ ↗️), a keycap, a flag, a ZWJ sequence and its skin tones.
 */

// Marks of the interface that are in the dingbat block but are text.
const TEXT_MARKS = '★☆✓✔✕✖✗✘';

const ATOM =
  String.raw`(?:\p{Emoji_Presentation}|[\u{1F000}-\u{1FAFF}]` +
  String.raw`|(?![${TEXT_MARKS}])(?=\p{Extended_Pictographic})[\u{2600}-\u{27BF}]` +
  String.raw`|\p{Extended_Pictographic}️|[#*0-9]️?⃣)`;

const RUN = String.raw`${ATOM}(?:[︎️]|‍${ATOM}|[\u{1F3FB}-\u{1F3FF}]|[\u{E0020}-\u{E007F}])*`;

// An emoji run with the blanks hugging it: removing the picture must not leave
// «обед  45 мин» or «** Обед**» behind.
const EMOJI = new RegExp(`([ \\t]*)(${RUN})([ \\t]*)`, 'gu');

const WORD = /[\p{L}\p{N}]/u;

export function stripEmoji(text: string): string {
  return text.replace(EMOJI, (match, before: string, _run: string, after: string, offset: number) => {
    const prev = text[offset - 1];
    const next = text[offset + match.length];
    // A line's own indent survives (a nested Markdown list rides on it).
    if (prev === undefined || prev === '\n' || prev === '\r') return before;
    if (next === undefined || next === '\n' || next === '\r') return '';
    if (before && after) return ' ';
    // «Привет😀мир» must not become one word; «**🍽 Обед**» must not gain a gap.
    return WORD.test(prev) && WORD.test(next) ? ' ' : '';
  });
}
